import type { RouteObject } from "react-router-dom";

import { LoginLayout } from "@components/LoginLayout/LoginLayout";
import { Login } from "@pages/Login/Login";
import { LoginCameleon } from "@pages/LoginCameleon/LoginCameleon";
import { LoginReset } from "@pages/LoginReset/LoginReset";
import { PasswordResetConfirmation } from "@pages/PasswordResetConfirmation/PasswordResetConfirmation";

import { ROUTES } from "./router.constants";

export const loginRoutes: RouteObject[] = [
  {
    path: ROUTES.LOGIN,
    element: (
      <LoginLayout>
        <Login />
      </LoginLayout>
    ),
  },
  {
    path: ROUTES.LOGIN_RESET,
    element: (
      <LoginLayout>
        <LoginReset />
      </LoginLayout>
    ),
  },
  {
    path: ROUTES.LOGIN_FIRST_CONNECTION,
    element: (
      <LoginLayout>
        <PasswordResetConfirmation />
      </LoginLayout>
    ),
  },
  {
    path: ROUTES.LOGIN_RESET_CONFIRM,
    element: (
      <LoginLayout>
        <PasswordResetConfirmation />
      </LoginLayout>
    ),
  },
  {
    path: ROUTES.LOGIN_CAMELEON,
    element: <LoginCameleon />,
  },
];
